<template>
  <q-card class="shadow-10 q-ma-md">
    <q-card-section class="text-center q-gutter-xs">
      <q-chip clickable
              v-if="$store.state.roles.some(v=>['admin','can_see_porcant', 'user_sell'].includes(v)) && item.CommissionAllSale"
              square
              color="red" text-color="white"
              style="direction: ltr"
              :label="(!item.CommissionAllSale || item.CommissionAllSale===0) && item.Commission!==0?(Math.round((profit * (1/3.0)) + (item.TargetPayProfit * (2/3.0)))).toLocaleString():profit.toLocaleString()">
      </q-chip>
      <q-space v-if="!item.CommissionAllSale"/>
      <q-btn label="محاسبه پورسانت" color="indigo"
             v-if="($store.state.roles.some(v=>['admin'].includes(v)) || parseInt($store.state.userId) === item.Sale_UserID) && !item.CommissionAllSale"
             text-color="white" icon="preview"
             @click="showCommisionGoodsInfo(item)"/>

      <q-btn label="لیست فاکتورهای تسویه نشده" color="indigo"
             v-if="($store.state.roles.some(v=>['admin'].includes(v)) || parseInt($store.state.userId) === item.Sale_UserID) && !item.CommissionAllSale"
             text-color="white" icon="preview"
             @click="showAgentFactorNotPay(item)"/>

    </q-card-section>
    <q-card-section class="no-padding text-center">
      <apexchart id="order" height="300" type="donut" :options="chartOptions" :series="series"></apexchart>
      <q-btn label="صدور سند مالی پورسانت" color="indigo"
             flat
             :disable="preventPorsantDocument && preventPorsantDocument>0"
             v-if="$store.state.roles.some(v=>['admin','can_issue_commision_finance_document'].includes(v))
             && item.CommissionAllSale && profit>0 && progressSalePrice>=salePrice/2"
             @click="issueCommisionFinanceDocument"
             icon="attach_money"/>
    </q-card-section>

    <q-dialog v-model="factorListDialog" maximized>
      <AgentsFactorsList :user-id="selectedUserId" :start-date="startDate" :end-date="endDate"
                         :agent-name="selectedAgentName"/>
    </q-dialog>

    <q-dialog v-model="targetGoodsInfo" maximized>
      <TargetGoodsInfo :agent-name="selectedAgentName" :user-id="selectedUserId" :start-date="startDate"
                       :end-date="endDate"/>
    </q-dialog>
    <q-dialog v-model="commisionGoodsList" maximized>
      <AgentsCommisionFactorListDesktop :target-id="targetId" v-if="!$q.screen.lt.md" :agent-name="selectedAgentName"
                                        :user-id="selectedUserId" :end-date="endDate"
                                        :sale-price="salePrice"
                                        :prevent-porsant-document="preventPorsantDocument"
                                        :progress-sale-price="progressSalePrice"
                                        :start-date="startDate"/>
      <AgentsCommisionFactorListMobile v-if="$q.screen.lt.md" :agent-name="selectedAgentName"
                                       :user-id="selectedUserId"
                                       :target-id="targetId"
                                       :sale-price="salePrice"
                                       :prevent-porsant-document="preventPorsantDocument"
                                       :progress-sale-price="progressSalePrice"
                                       :end-date="endDate"
                                       :start-date="startDate"/>
    </q-dialog>
    <q-dialog v-model="agentNotPayFactorListDialog" maximized>
      <FactorsList :start-date="startDate" :end-date="endDate" :user-id="selectedUserId" :is-dialog="true" />
    </q-dialog>
  </q-card>
</template>

<script>
import AgentsFactorsList from "@/components/Agents/FactorList/AgentsFactorsList";
import TargetGoodsInfo from "@/components/TargetReview/TargetGoodsInfo.vue";
import AgentsCommisionFactorListDesktop from "@/components/Agents/FactorList/AgentsCommisionFactorListDesktop.vue";
import AgentsCommisionFactorListMobile from "@/components/Agents/FactorList/AgentsCommisionFactorListMobile.vue";
import {mapActions} from "vuex";
import FactorsList from "@/components/Factor/FactorsList.vue";

export default {
  name: "UserFactorsInfo",
  components: {
    FactorsList,
    AgentsCommisionFactorListMobile, AgentsCommisionFactorListDesktop, TargetGoodsInfo, AgentsFactorsList},
  props: {
    item: {
      type: Object,
      required: true
    },
    series: {
      type: Array,
      default: () => {
      }
    },
    profit: {
      type: Number
    },
    targetProfit: {
      type: Number,
    },
    userId: {
      type: Number,
      required: false
    },
    startDate: {
      type: String,
      required: false
    },
    endDate: {
      type: String,
      required: false
    },
    targetId: {
      type: String,
      required: true
    },
    salePrice: {
      type: Number,
      required: true
    },
    progressSalePrice: {
      type: Number,
      required: true
    },
    preventPorsantDocument: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      agentNotPayFactorListDialog:false,
      commisionGoodsList: false,
      targetGoodsInfo: false,
      selectedUserId: -1,
      selectedAgentName: undefined,
      factorListDialog: false,
      chartOptions: {
        chart: {
          type: 'pie',
          fontFamily: "IRANSans, sans-serif",

        },
        title: {
          show: true,
          text: this.$store.state.roles.some(v => ['admin', 'salemanager'].includes(v)) ? `${this.item.Username}` : 'فاکتورهای که سفارش دهنده و یا برگشت دهنده بوده اید',
          align: 'center',
          wrap: true
        },
        dataLabels: {
          enabled: true,
        },
        labels: ['فاکتور', 'فاکتور برگشتی'],
        legend: {
          position: 'top',
          formatter: function (val) {
            return val.toLocaleString()
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString()
            }
          }
        },
        responsive: [{
          options: {
            chart: {},
            legend: {
              show: false,
            }
          }
        }]
      },
    }
  },
  methods: {
    ...mapActions({
      addCommisionFianceDocument: 'Agents/addCommissionFinanceDocument'
    }),
    issueCommisionFinanceDocument() {
      this.addCommisionFianceDocument({
        price: this.profit,
        userId: this.userId,
        targetId: this.targetId
      }).then((res) => {
        if (res.result === 1) {
          this.items[0].IssueUser = this.$store.state.userId
        }
      })
    },
    showFactorList(itemInfo) {
      this.selectedAgentName = itemInfo.Username
      this.factorListDialog = true
    },
    showTargetGoodsInfo(itemInfo) {
      this.selectedUserId = itemInfo.Sale_UserID
      this.selectedAgentName = itemInfo.Username
      this.targetGoodsInfo = true
    },
    showCommisionGoodsInfo(itemInfo) {
      this.selectedUserId = itemInfo.Sale_UserID
      this.selectedAgentName = itemInfo.Username
      this.commisionGoodsList = true
    },
    showAgentFactorNotPay(itemInfo){
      this.selectedUserId = itemInfo.Sale_UserID
      this.selectedAgentName = itemInfo.Username
      this.agentNotPayFactorListDialog = true
    }
  },
  created() {
  }
}
</script>

<style scoped>

</style>